import { actionEsOnMessage } from '@skynet/data-ws-es';

import { cancelReport, confirmReport, requestReport } from './actions';
import type { ReportsState } from 'src/store/shared/reports/factory';
import { createReportsExtraReducers, initialReportSlice } from 'src/store/shared/reports/factory';

export const initialState: ReportsState = {
  requestStatus: null,
  error: null,

  reportPreview: null,
  reportId: null,
};

const { reducer, actions } = initialReportSlice({
  prefix: 'es',
  initialState,
  messages: actionEsOnMessage,
  extraReducers: createReportsExtraReducers(requestReport, confirmReport, cancelReport),
});

export const tradingReportsActions = {
  ...actions,
  requestReport,
  confirmReport,
  cancelReport,
};

export default reducer;
